<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="">
        <el-button type="success" @click="search">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>
          {{ getNameByValue(coopType, row.manage_role) }}
        </div>
      </template>
      <template #end_time="{ row }">
        <div @click="openTimeUpdate(row)">
          {{ row.end_time }}<i class="el-icon-edit time_edit"></i>
        </div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="danger" v-if="row.status == 4">退款</el-tag>
          <el-tag type="success" v-if="row.status == 1">可用</el-tag>
          <el-tag type="info" v-if="row.status == 2">不可用</el-tag>
          <el-tag type="warning" v-if="row.status == 0">待支付</el-tag>
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button v-if="row.status == 1" type="primary" @click="openRatio(row)">设置分成</el-button>
          <el-button v-if="row.status == 1" type="danger" @click="updateStatus(row,2)">停用</el-button>
          <el-button v-if="row.status == 2" type="success" @click="updateStatus(row,1)">开通使用</el-button>
        </div>
      </template>
    </auto-table>

    <h2>合作保证金</h2>
     <auto-table
      :DataList="unPayDataList"
      :option="unPayOption"
      :total="unPayTotal"
      @changePage="getUnPayList"
    >
      <template #type>
        <div>
          保证金
        </div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="success" v-if="row.status == 1">已支付</el-tag>
          <el-tag type="info" v-if="row.status == 2">取消</el-tag>
          <el-tag type="warning" v-if="row.status == 0">待支付</el-tag>
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button type="danger" v-if="row.status == 0" @click="cancelPartner(row)">取消合作</el-button>
        </div>
      </template>
    </auto-table>


     <el-dialog
      :visible.sync="updateShow"
      width="50%"
      title="合作门店设置"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item label="合作门店" required>
          {{curItem.mechanism ? curItem.mechanism.mechanism_name : ''}}
        </el-form-item>
        <el-form-item label="合作时间" required>
          <el-date-picker
            v-model="curItem.start_time"
            value-format="yyyy-MM-dd 00:00:00"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-date-picker
            v-model="curItem.end_time"
            value-format="yyyy-MM-dd 23:59:59"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateShow = false">取 消</el-button>
        <el-button  type="primary" @click="updateEndTime()"
          >修 改</el-button
        >
      </span>
    </el-dialog>


    <bindEdit @success="search" ref="edit"></bindEdit>
    <settingRatio ref="ratioRef"></settingRatio>
  </div>
</template>

<script>
import { coopType } from "../dict";
import settingRatio from './settingRatio.vue';
import bindEdit from './bindEdit.vue';
export default {
  components: {
    bindEdit,
    settingRatio
  },
  data() {
    return {
      updateShow: false,
      curItem: {},
      coopType,
      DataList: [],
      Option: [
        { name: "机构名称", value: "mechanism.mechanism_name" },
        { name: "合作类型", value: "type", type: "custom" },
        { name: "状态", value: "status", type: "custom" },
        { name: "到期时间", value: "end_time" ,type: "custom"},
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      unPayDataList: [],
      unPayOption: [
        { name: "金额", value: "amount" },
        { name: "类型", value: "type", type: "custom" },
        { name: "状态", value: "status", type: "custom" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      unPayTotal: 0,
      type: "",
      admin_id: "",
      show: false,
    };
  },
  mounted() {
    this.admin_id = this.$route.query.id;
  },

  methods: {
    openRatio(row){
        this.$refs.ratioRef.open(row)
    },
    search(){
        this.getList(1);
        this.getUnPayList(1)
    },
    load() {
      if (this.admin_id && this.DataList.length == 0) {
        this.getList(1);
        this.getUnPayList(1)
      }
    },
    cancelPartner(row) {
      this.$confirm("确认取消与门店的合作？").then((res) => {
        this.$post("/user/mechanismUnionPrice/cancelEnroll", { id: row.id }).then((res) => {
          this.search();
        });
      });
    },
    updateStatus(row,status) {
      this.$post("/user/adminMec/update", { id: row.id,status}).then((res) => {
          this.getList(1);
        });
    },
    openTimeUpdate(row){
      this.curItem = row
      this.updateShow = true
    },
    upType(row) {
      this.$refs.edit.open(row);
    },
    add() {
      this.$refs.edit.open();
    },
    updateEndTime(){
      let data = {
        id: this.curItem.id,
        start_time: this.curItem.start_time,
        end_time: this.curItem.end_time
      }

      this.$post('/user/adminMec/update',data).then((res) => {
        this.updateShow = false
          this.getList(1);
        });
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/adminMec/queryByMessage",
        params: {
          currentPage: page,
          pageSize: 10,
          admin_id: this.admin_id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
     //获取列表
    getUnPayList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/coachUnpaidAmount/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          admin_id: this.admin_id
        },
      }).then((res) => {
        this.unPayDataList = res.data.data.rows;
        this.unPayTotal = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.time_edit{
  color: rgb(78, 151, 235);
}
</style>